import { Router } from '@angular/router';
import { ChangeRegionComponent } from 'app/core/change-region/change-region.component';
import { ServiceType } from 'app/core/service-type.model';
import { settings } from 'app/core/settings';
import { getPolicyData } from 'app/services/policy.service';
import { UIDialogService } from 'app/ui/dialog/dialog.service';
import { AccountService } from 'app/user/account.service';
import { AuthService } from 'app/user/auth.service';
import { UserSettingsService } from 'app/user/user-settings.service';
import { UserService } from 'app/user/user.service';
import { ButtonTypes } from './../../ui/button/button.component';
var ShellComponent = /** @class */ (function () {
    function ShellComponent(_authService, _accountService, _router, _userService, _userSettingsService, dialogService) {
        this._authService = _authService;
        this._accountService = _accountService;
        this._router = _router;
        this._userService = _userService;
        this._userSettingsService = _userSettingsService;
        this.dialogService = dialogService;
        this.buttonTypes = ButtonTypes;
        var policyData = getPolicyData(this._userSettingsService.region);
        this.linkPrivatePolicy = policyData.privacyPolicyUrl;
        this.linkCookiePolicy = policyData.cookiePolicyUrl;
        var url = this._router.url;
        if (url.indexOf('documents') !== -1) {
            this._userSettingsService.serviceType = ServiceType.DocumentCapture;
        }
        if (url.indexOf('invoices') !== -1) {
            this._userSettingsService.serviceType = ServiceType.InvoiceCapture;
        }
    }
    Object.defineProperty(ShellComponent.prototype, "serviceType", {
        get: function () {
            return this._userSettingsService.serviceType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShellComponent.prototype, "userName", {
        get: function () {
            return this._userService.userName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShellComponent.prototype, "settings", {
        get: function () {
            return settings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShellComponent.prototype, "showBackground", {
        get: function () {
            return this._userSettingsService.showBackground;
        },
        enumerable: true,
        configurable: true
    });
    ShellComponent.prototype.hasServiceType = function (serviceType) {
        return this._userSettingsService.serviceType === serviceType;
    };
    ShellComponent.prototype.logout = function () {
        var _this = this;
        this._authService
            .logout()
            .subscribe(function () { return _this._router.navigateByUrl('/login'); });
    };
    ShellComponent.prototype.changeRegion = function () {
        this.dialogService.open(ChangeRegionComponent);
    };
    return ShellComponent;
}());
export { ShellComponent };
